__turbopack_context__.v({
  "bottomSheet": "ProductCardMerch-module__j9J1Ta__bottomSheet",
  "merchSizing": "ProductCardMerch-module__j9J1Ta__merchSizing",
  "root": "ProductCardMerch-module__j9J1Ta__root",
});
